// // @ts-nocheck
// import React, { useEffect } from 'react';
// import { useResolvedPath, useMatch, NavLink, useLocation, matchPath } from 'react-router-dom';
// import menus from './../../config/app-menu.jsx';
// import { slideUp } from './../../composables/slideUp.js';
// import { slideToggle } from './../../composables/slideToggle.js';
// import useGetSysCode from '@hooks/useGetSysCode';
// import { useTranslation } from 'react-i18next';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';

// function NavItem({ menu, ...props }) {
//   const { t } = useTranslation();
//   let path = menu.path ? menu.path : '';
//   let resolved = useResolvedPath(path);
//   let match = useMatch({ path: resolved.pathname });
//   let location = useLocation();

//   useEffect(() => {
//     const handleClick = function (e) {
//       e.preventDefault();
//       const target = this.nextElementSibling;

//       // Only close siblings at the same level
//       const parentMenu = this.closest('.menu-submenu') || this.closest('.menu');
//       const siblingMenus = parentMenu ? Array.from(parentMenu.children) : [];

//       siblingMenus.forEach(menu => {
//         const otherTarget = menu.querySelector('.menu-submenu');
//         if (otherTarget && otherTarget !== target) {
//           slideUp(otherTarget, expandTime);

//           const otherTargetMenuItem = otherTarget.closest('.menu-item');
//           if (otherTargetMenuItem && otherTargetMenuItem.classList) {
//             otherTargetMenuItem.classList.remove('expand');
//             otherTargetMenuItem.classList.add('closed');
//           }
//         }
//       });

//       const targetItemElm = target?.closest('.menu-item');
//       if (targetItemElm && targetItemElm.classList) {
//         if (
//           targetItemElm.classList.contains('expand') ||
//           (targetItemElm.classList.contains('active') && !target.style.display)
//         ) {
//           targetItemElm.classList.remove('expand');
//           targetItemElm.classList.add('closed');
//           slideToggle(target, expandTime);
//         } else {
//           targetItemElm.classList.add('expand');
//           targetItemElm.classList.remove('closed');
//           slideToggle(target, expandTime);
//         }
//       }
//     };

//     const handleSidebarMenuToggle = (menus, expandTime) => {
//       menus.forEach(menu => {
//         menu.removeEventListener('click', handleClick); // Ensure old listeners are removed
//         menu.addEventListener('click', handleClick);
//       });
//     };

//     // Get sidebar expand time
//     const expandTime = 0;

//     const menuBaseSelector = '.app-sidebar .menu > .menu-item.has-sub';
//     const submenuBaseSelector = ' > .menu-submenu > .menu-item.has-sub';

//     // Select menu items
//     const menus = Array.from(document.querySelectorAll(menuBaseSelector + ' > .menu-link'));
//     const submenusLvl1 = Array.from(
//       document.querySelectorAll(menuBaseSelector + submenuBaseSelector + ' > .menu-link')
//     );
//     const submenusLvl2 = Array.from(
//       document.querySelectorAll(menuBaseSelector + submenuBaseSelector + submenuBaseSelector + ' > .menu-link')
//     );

//     handleSidebarMenuToggle([...menus, ...submenusLvl1, ...submenusLvl2], expandTime);

//     return () => {
//       [...menus, ...submenusLvl1, ...submenusLvl2].forEach(menu => {
//         menu.removeEventListener('click', handleClick);
//       });
//     };
//   }, []);

//   if (menu.is_header) {
//     return <div className='menu-header'>{t(menu?.title)}</div>;
//   }

//   if (menu.is_divider) {
//     return <div className='menu-divider'></div>;
//   }

//   let match2 = matchPath({ path: path, end: false }, location.pathname);

//   let icon = menu.icon && (
//     <div className='menu-icon'>
//       <i className={menu.icon}></i>
//     </div>
//   );
//   let img = menu.img && (
//     <div className='menu-icon-img'>
//       <img src={menu.img} alt='' />
//     </div>
//   );
//   let caret = menu.children && !menu.badge && (
//     <div className='menu-caret'>
//       <b className='caret'></b>
//     </div>
//   );
//   let label = menu.label && <span className='menu-label ms-5px'>{menu.label}</span>;
//   let badge = menu.badge && <div className='menu-badge'>{menu.badge}</div>;
//   let highlight = menu.highlight && <i className='fa fa-paper-plane text-theme'></i>;
//   let title = menu.title && (
//     <div className='menu-text'>
//       {t(menu?.title)} {label} {highlight}
//     </div>
//   );

//   return (
//     <div className={'menu-item' + (match || match2 ? ' active' : '') + (menu.children ? ' has-sub' : '')}>
//       <NavLink className='menu-link' to={menu.path} {...props}>
//         {img} {icon} {title}
//         {caret} {badge}
//       </NavLink>

//       {menu.children && (
//         <div className='menu-submenu'>
//           {menu.children.map((submenu, i) => (
//             <NavItem key={i} menu={submenu} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function SidebarNav() {
//   // const { sysCode } = useGetSysCode();
//   // console.log(sysCode);
//   const { moduleCode } = useGetSysCode();
//   console.log(moduleCode);

//   const { HasPermission } = usePermissions();

//   // العثور على القائمة الخاصة بالنظام الحالي بناءً على الكود
//   const currentSystemMenu = menus.find(item => item.System === moduleCode);

//   // تصفية القائمة لإظهار العناصر النشطة أو الصفحة الرئيسية
//   // const filteredMenu = currentSystemMenu?.menu?.filter(
//   //   item => item.title === 'HomePage' || item.isActive || item.children?.some(child => child.isActive)
//   // );

//   // const filteredMenu = currentSystemMenu?.menu.filter(item => {
//   //   // اعرض العناوين والصفحة الرئيسية دائمًا
//   //   if (item.is_header || item.title === 'HomePage') {
//   //     return true;
//   //   }

//   //   // إذا كان العنصر غير نشط وليس لديه أبناء نشطين، لا تعرضه
//   //   if (!item.children?.some(child => child.isActive)) {
//   //     return false;
//   //   }

//   //   // إذا كان العنصر غير نشط، لا تعرضه
//   //   if (!item.isActive) {
//   //     return false;
//   //   }

//   //   // إذا كان لديه permission، تحقق منه
//   //   if (item.permission) {
//   //     return HasPermission(item.permission);
//   //   }

//   //   // العناصر بدون permission تعرض دائمًا
//   //   return true;
//   // });

//   const filteredMenu = currentSystemMenu?.menu.filter(item => {
//     // اعرض العناوين والصفحة الرئيسية دائمًا
//     if (item.is_header || item.title === 'HomePage') {
//       return true;
//     }

//     // تحقق من الأبناء (نشط + عنده صلاحية أو بدون صلاحية)
//     const hasActiveChild = item.children?.some(child => {
//       if (!child.isActive) return false;
//       if (child.permission) {
//         return HasPermission(child.permission);
//       }
//       return true;
//     });

//     // إذا كان العنصر غير نشط وليس لديه أبناء نشطين مع صلاحية، لا تعرضه
//     if (!item.isActive && !hasActiveChild) {
//       return false;
//     }

//     // إذا كان لديه permission، تحقق منه
//     if (item.permission) {
//       return HasPermission(item.permission);
//     }

//     // العناصر بدون permission تعرض دائمًا
//     return true;
//   });

//   return (
//     <div className='menu'>
//       {filteredMenu?.map((menu, i) => (
//         <NavItem key={i} menu={menu} />
//       ))}
//     </div>
//   );
// }

// export default SidebarNav;


// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useResolvedPath, useMatch, NavLink, useLocation, matchPath } from 'react-router-dom';
import menus from './../../config/app-menu.jsx';
import { slideUp } from './../../composables/slideUp.js';
import { slideToggle } from './../../composables/slideToggle.js';
import useGetSysCode from '@hooks/useGetSysCode';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

// 1. إضافة مكون التحميل المسبق الجديد هنا
const PrefetchNavLink = ({ to, importer, children, ...props }) => {
  const [isPrefetched, setIsPrefetched] = useState(false);

  const handleMouseEnter = () => {
    // إذا لم يتم التحميل مسبقاً، وهناك دالة استيراد في المنيو، قم بتشغيلها
    if (!isPrefetched && importer) {
      importer().catch(() => {}); // تجاهل صامت لأي خطأ في الشبكة
      setIsPrefetched(true);
    }
  };

  return (
    <NavLink 
      to={to} 
      onMouseEnter={handleMouseEnter} 
      {...props}
    >
      {children}
    </NavLink>
  );
};




function NavItem({ menu, ...props }) {
  const { t } = useTranslation();
  let path = menu.path ? menu.path : '';
  let resolved = useResolvedPath(path);
  let match = useMatch({ path: resolved.pathname });
  let location = useLocation();

  useEffect(() => {
    const handleClick = function (e) {
      e.preventDefault();
      const target = this.nextElementSibling;

      // Only close siblings at the same level
      const parentMenu = this.closest('.menu-submenu') || this.closest('.menu');
      const siblingMenus = parentMenu ? Array.from(parentMenu.children) : [];

      siblingMenus.forEach(menu => {
        const otherTarget = menu.querySelector('.menu-submenu');
        if (otherTarget && otherTarget !== target) {
          slideUp(otherTarget, expandTime);

          const otherTargetMenuItem = otherTarget.closest('.menu-item');
          if (otherTargetMenuItem && otherTargetMenuItem.classList) {
            otherTargetMenuItem.classList.remove('expand');
            otherTargetMenuItem.classList.add('closed');
          }
        }
      });

      const targetItemElm = target?.closest('.menu-item');
      if (targetItemElm && targetItemElm.classList) {
        if (
          targetItemElm.classList.contains('expand') ||
          (targetItemElm.classList.contains('active') && !target.style.display)
        ) {
          targetItemElm.classList.remove('expand');
          targetItemElm.classList.add('closed');
          slideToggle(target, expandTime);
        } else {
          targetItemElm.classList.add('expand');
          targetItemElm.classList.remove('closed');
          slideToggle(target, expandTime);
        }
      }
    };

    const handleSidebarMenuToggle = (menus, expandTime) => {
      menus.forEach(menu => {
        menu.removeEventListener('click', handleClick); // Ensure old listeners are removed
        menu.addEventListener('click', handleClick);
      });
    };

    // Get sidebar expand time
    const expandTime = 0;

    const menuBaseSelector = '.app-sidebar .menu > .menu-item.has-sub';
    const submenuBaseSelector = ' > .menu-submenu > .menu-item.has-sub';

    // Select menu items
    const menus = Array.from(document.querySelectorAll(menuBaseSelector + ' > .menu-link'));
    const submenusLvl1 = Array.from(
      document.querySelectorAll(menuBaseSelector + submenuBaseSelector + ' > .menu-link')
    );
    const submenusLvl2 = Array.from(
      document.querySelectorAll(menuBaseSelector + submenuBaseSelector + submenuBaseSelector + ' > .menu-link')
    );

    handleSidebarMenuToggle([...menus, ...submenusLvl1, ...submenusLvl2], expandTime);

    return () => {
      [...menus, ...submenusLvl1, ...submenusLvl2].forEach(menu => {
        menu.removeEventListener('click', handleClick);
      });
    };
  }, []);

  if (menu.is_header) {
    return <div className='menu-header'>{t(menu?.title)}</div>;
  }

  if (menu.is_divider) {
    return <div className='menu-divider'></div>;
  }

  let match2 = matchPath({ path: path, end: false }, location.pathname);

  let icon = menu.icon && (
    <div className='menu-icon'>
      <i className={menu.icon}></i>
    </div>
  );
  let img = menu.img && (
    <div className='menu-icon-img'>
      <img src={menu.img} alt='' />
    </div>
  );
  let caret = menu.children && !menu.badge && (
    <div className='menu-caret'>
      <b className='caret'></b>
    </div>
  );
  let label = menu.label && <span className='menu-label ms-5px'>{menu.label}</span>;
  let badge = menu.badge && <div className='menu-badge'>{menu.badge}</div>;
  let highlight = menu.highlight && <i className='fa fa-paper-plane text-theme'></i>;
  let title = menu.title && (
    <div className='menu-text'>
      {t(menu?.title)} {label} {highlight}
    </div>
  );

  return (
    <div className={'menu-item' + (match || match2 ? ' active' : '') + (menu.children ? ' has-sub' : '')}>
      
      {/* 2. استبدال NavLink بـ PrefetchNavLink وتمرير importer */}
      <PrefetchNavLink 
        className='menu-link' 
        to={menu.path} 
        importer={menu.importer} 
        {...props}
      >
        {img} {icon} {title}
        {caret} {badge}
      </PrefetchNavLink>

      {menu.children && (
        <div className='menu-submenu'>
          {menu.children.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

function SidebarNav() {
  const { moduleCode } = useGetSysCode();
  const { HasPermission } = usePermissions();

  const currentSystemMenu = menus.find(item => item.System === moduleCode);

  const filteredMenu = currentSystemMenu?.menu.filter(item => {
    if (item.is_header || item.title === 'HomePage') {
      return true;
    }

    const hasActiveChild = item.children?.some(child => {
      if (!child.isActive) return false;
      if (child.permission) {
        return HasPermission(child.permission);
      }
      return true;
    });

    if (!item.isActive && !hasActiveChild) {
      return false;
    }

    if (item.permission) {
      return HasPermission(item.permission);
    }

    return true;
  });

  return (
    <div className='menu'>
      {filteredMenu?.map((menu, i) => (
        <NavItem key={i} menu={menu} />
      ))}
    </div>
  );
}

export default SidebarNav;